import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';

const ProgressBar = props => (
    <div className={getComponentClasses('progress-bar', props.variations)}>
        <div className="progress-bar__progress" style={{ width: props.progress + '%' }}>
            {props.children}
        </div>
    </div>
);

ProgressBar.propTypes = {
    variations: PropTypes.array,
    progress: PropTypes.number.isRequired,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/ProgressBar.jsx